<template>
	<!--

DOC

riferimento dal compoentne generico da reflect-component
si occupa del passaggio finale di render elemento

-->

	<div v-if="element.type === 'number'">
		<!--    input numero-->
		<el-input-number :disabled="!isEditable" class="input_cst" v-model="element.value"></el-input-number>
	</div>
	<div v-else-if="element.type === 'img'">
		<!--    input immagine (base64)-->
		<input
			v-if="element.value == []"
			@change="handleImage($event, element)"
			class="custom-input"
			type="file"
			accept="image/*"
		/>
		<img v-else :src="element.value" alt="" />
	</div>
	<div v-else-if="element.type === 'editor'">
		<!--<text-editor @edit="textedit" :isEditable="isEditable" :value="element.value"  ></text-editor>-->
		<Prosemirror
			@edit="textedit"
			:isEditable="isEditable"
			:value="element.value"
			@editVal="
				data => {
					element.value = data
				}
			"
		></Prosemirror>
	</div>

	<div v-else-if="element.type === 'seen'">
		<!--<text-editor @edit="textedit" :isEditable="isEditable" :value="element.value"  ></text-editor>-->
		<Prosemirror
			@edit="textedit"
			:isEditable="isEditable"
			:value="element.value"
			@editVal="
				data => {
					element.value = data
				}
			"
		></Prosemirror>
	</div>
	<div v-else>
		<!--    default text-->

		<el-input :disabled="!isEditable" class="input_cst" v-model="element.value"></el-input>
	</div>
</template>
<script>
import axios from "axios"
import { uuid } from "@/modules/builder/utils/utils"
import Prosemirror from "@/modules/prosemirror/component/main"
export default {
	name: "InputComponent",
	components: {
		Prosemirror
	},
	props: {
		element: {
			required: true,
			type: Object
		},
		isEditable: {
			required: true,
			type: Boolean
		}
	},
	data() {
		return {
			employes: []
		}
	},
	mounted() {},
	methods: {
		textedit(val) {
			this.element.value = JSON.parse(val)
		},
		handleImage(e, element) {
			/**
			 * DOC
			 * l'immagine viene codificata come base64.
			 * la funzione si occupa di ciò
			 *
			 * */

			var file = e.target.files[0] // get first file
			var reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = function () {
				element.value = reader.result
			}
			reader.onerror = function (error) {
				console.error("Error: ", error)
			}
		},

		uuid
	}
}
</script>
